import { type ModalProps } from '../types';
import styles from '../Modal@desktop.module.css';

export const getContainerClassName = (size: ModalProps['size']) => {
    switch (size) {
        case 'fullscreen':
            return styles.Modal_container_size_fullscreen;

        case 'extra-large':
            return styles.Modal_container_size_extra_large;

        default:
            return undefined;
    }
};
